import { useMutation } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { toast } from "sonner"

export interface ResetPasswordResponse {
  message: string;
  data: {
    email: string;
    newPassword: string;
  }
}

export const resetUserPasswordAPI = async (userId: string) => {
  const response = await baseAPI.post<ResetPasswordResponse>(`/users/${userId}/reset-password`);
  return response.data;
};

export const useResetUserPassword = () => {
  return useMutation({
    mutationFn: (userId: string) => resetUserPasswordAPI(userId),
    onSuccess: () => toast.success('Password reset successfully'),
    onError: () => toast.error('Failed to reset password'),
  });
};
